import React from "react";

export default function Logo({ variant = "dark", className = "" }) {
  // variant: 'dark' -> ink text on sand bg; 'light' -> sand text on ink bg
  const isDark = variant === "dark";
  return (
    <div
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="Mirexilora"
      data-testid="brand-logo"
    >
      <svg
        width="34"
        height="34"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="64" height="64" rx="12" fill={isDark ? "#1A211C" : "#F6F4EE"} />
        <path
          d="M14 48V16L24 30L32 20L40 30L50 16V48"
          stroke={isDark ? "#C5B293" : "#1A211C"}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M20 48H44" stroke={isDark ? "#3D4F42" : "#3D4F42"} strokeWidth="3" strokeLinecap="round" />
        <circle cx="32" cy="52" r="1.7" fill={isDark ? "#C5B293" : "#1A211C"} />
      </svg>
      <div className="leading-tight">
        <div
          className="font-serif tracking-tight"
          style={{
            fontSize: "1.35rem",
            color: isDark ? "#1A211C" : "#F6F4EE",
            fontWeight: 600,
            letterSpacing: "-0.01em",
          }}
        >
          Mirexilora
        </div>
      </div>
    </div>
  );
}
